import React from "react";
import get from "lodash/get";
import find from "lodash/find";
import forEach from "lodash/forEach";
import classnames from "classnames";
import { connect } from "react-redux";
import {
  Alert,
  Layout,
  List,
  Badge,
  Button,
  Row,
  Col,
  Breadcrumb,
  Modal,
  message, Icon,
} from "antd";

import SettingsRoleForm from "../../components/SettingsRoleForm/SettingsRoleForm";
import classes from "./SettingsRoles.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getSettingsRolesRequest,
  getPermissionsStructureRequest,
  getPermissionsFileRequest,
} from "../../api/requests";
import { logout, setPermissions } from "../../reducers/user/actions";
import {
  getRoleCreatePermission,
  getUserToken,
} from "../../reducers/user/selectors";
import { withNamespaces } from "react-i18next";
import SettingsRolesUpload from "./SettingsRolesUpload";

const { Content } = Layout;

class SettingsRoles extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rolesList: [],
      permissionsStructure: [],
      permissionsStructureKeys: {},
      roleEdit: null,
      selectedRole: null,
      errorMessage: "",
      responseMessage: "",
      isDownloadPermissions: false,
      isUploadPermissions: false,
    };
  }

  async componentDidMount() {
    this.getRolesList();
    this.getPermissionsStructure();
  }

  getRolesList = async () => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getSettingsRolesRequest();
      this.setState({ rolesList: data });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        subject: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  };

  getPermissionsStructure = async () => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getPermissionsStructureRequest();

      const permissionsStructure = {};
      const permissionsStructureKeys = {};

      forEach(data, (item) => {
        const permissionItem = {};
        const permissions = [...item.permissions];
        const selectType = {};
        const checkboxType = [];

        permissions.forEach(
          ({ id, key, value, type, message, label, group }) => {
            permissionsStructureKeys[key] = `${id}`;

            if (group) {
              selectType[`group_${group.id}`] = selectType[`group_${group.id}`]
                ? [
                    ...selectType[`group_${group.id}`],
                    { key: `${id}`, value, name: group.name },
                  ]
                : [{ key: `${id}`, value, name: group.name }];
            } else {
              checkboxType.push({
                key: `${id}`,
                name: value,
                label: label ? label : message ? { type, message } : null,
              });
            }
          }
        );

        permissionItem.name = item.value;
        permissionItem.fields = [
          ...Object.keys(selectType).map((key) => ({
            key,
            name: get(selectType, `${key}[0].name`),
            permissions: selectType[key],
          })),
        ];

        if (checkboxType.length > 0) {
          permissionItem.fields = [...permissionItem.fields, ...checkboxType];
        }

        permissionsStructure[item.id] = permissionItem;
      });

      this.setState({ permissionsStructure, permissionsStructureKeys });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        subject: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  };

  onSelectRole = (role) => () => {
    this.setState({ selectedRole: null }, () => {
      this.setState({ selectedRole: role });
    });
  };

  onRoleEditHide = () => {
    this.setState({ selectedRole: null });
  };

  onRoleEditSubmit = async (roleID) => {
    this.props.setPermissions(this.props.userToken);
    await this.getRolesList();

    this.setState({ selectedRole: null }, () => {
      this.setState({
        selectedRole: find(
          this.state.rolesList,
          (roleItem) => roleItem.id === roleID
        ),
      });
    });
  };

  onAddRole = () => {
    this.setState({ selectedRole: null }, () => {
      this.setState({ selectedRole: {} });
    });
  };

  onExportPermissions = async () => {
    try {
      this.setState(() => ({
        isDownloadPermissions: true,
      }));

      let data = null;

      const response = await getPermissionsFileRequest();
      data = response.data;

      const blob = new Blob([data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `export-permissions.csv`;
      link.click();
    } catch (e) {
      message.error("Error");
      console.log(e);
    }

    this.setState(() => ({
      isDownloadPermissions: false,
    }));
  };

  render() {
    const {
      rolesList,
      errorMessage,
      responseMessage,
      permissionsStructure,
      permissionsStructureKeys,
      selectedRole,
      isDownloadPermissions,
      isUploadPermissions,
      isLoading
    } = this.state;
    const { roleCreatePermission } = this.props;

    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("NamespaceSettingsRoles:Role Management")}
            </h3>
            <Breadcrumb>
              <Breadcrumb.Item href="/admin/settings">
                {this.props.i18n.t("Admin Settings")}
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {this.props.i18n.t("NamespaceSettingsRoles:Role Management")}
              </Breadcrumb.Item>
            </Breadcrumb>
            <br />

            <Row gutter={24}>
              <Col lg={12}>
                {roleCreatePermission && (
                  <div className={classes.roleActionWrapper}>
                    <Button type="primary" onClick={this.onAddRole}>
                      {this.props.i18n.t("Add role")}
                    </Button>
                    &nbsp;&nbsp;
                    <Button
                      type="primary"
                      onClick={this.onExportPermissions}
                      loading={isDownloadPermissions}
                    >
                      {this.props.i18n.t("Export all permissions by roles")}
                    </Button>
                    &nbsp;&nbsp;
                    <Button
                      type="primary"
                      onClick={() => {
                        this.setState({
                          isUploadPermissions: true,
                        });
                      }}
                      loading={isUploadPermissions}
                    >
                      {this.props.i18n.t("Upload all permissions by roles")}
                    </Button>
                  </div>
                )}
              </Col>
            </Row>

            <Row gutter={24}>
              <Col lg={6}>
                <p>
                  <b>
                    {this.props.i18n.t(
                      "NamespaceSettingsRoles:Select a role to edit"
                    )}
                  </b>
                </p>

                <List
                  className={classes.rolesList}
                  bordered
                  dataSource={rolesList}
                  renderItem={(item) => (
                    <List.Item
                      className={classnames(classes.roleItem, {
                        [classes.active]: item.id === get(selectedRole, "id"),
                      })}
                      onClick={this.onSelectRole(item)}
                    >
                      {item.name}

                      <Badge
                        count={item.state}
                        style={{
                          backgroundColor:
                            item.state === "active" ? "#49c850" : "#f00",
                        }}
                      />
                    </List.Item>
                  )}
                />
              </Col>

              <Col lg={18}>
                <p>&nbsp;</p>
                {isLoading && <Icon type="loading" />}

                {selectedRole && (
                  <SettingsRoleForm
                    permissionsStructureKeys={permissionsStructureKeys}
                    permissionsStructure={permissionsStructure}
                    {...selectedRole}
                    isNew={selectedRole && !selectedRole.id}
                    onSubmit={this.onRoleEditSubmit}
                    onCancel={this.onRoleEditHide}
                  />
                )}
              </Col>
            </Row>

            {errorMessage && <Alert type="error" message={errorMessage} />}

            {responseMessage && (
              <Alert type="success" message={responseMessage} />
            )}

            <Modal
              visible={isUploadPermissions}
              onCancel={() => {
                this.setState({ isUploadPermissions: false });
              }}
              footer={null}
            >
              {isUploadPermissions && (
                <SettingsRolesUpload
                  onSubmit={() => {
                    this.setState({
                      rolesList: [],
                      permissionsStructure: [],
                      permissionsStructureKeys: {},
                      roleEdit: null,
                      selectedRole: null,
                    });
                    this.getRolesList();
                    this.getPermissionsStructure();
                    this.setState({ isUploadPermissions: false });
                  }}
                  onCancel={() => {
                    this.setState({ isUploadPermissions: false });
                  }}
                />
              )}
            </Modal>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  roleCreatePermission: getRoleCreatePermission(state),
  userToken: getUserToken(state),
});

const mapDispatchToProps = { logout, setPermissions };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(SettingsRoles))
);


// WEBPACK FOOTER //
// ./src/containers/SettingsRoles/SettingsRoles.js